import {useIsomorphicLayoutEffect} from '@sail/engine';

type Config = {
  node: HTMLElement | null;
  options?: MutationObserverInit;
  handler: (records: MutationRecord[]) => void;
};

const defaultOptions: MutationObserverInit = {
  attributes: true,
  childList: true,
  subtree: true,
};

export function useMutationObserver({
  node,
  options = defaultOptions,
  handler,
}: Config): void {
  useIsomorphicLayoutEffect(() => {
    if (node) {
      const observer = new MutationObserver((mutations) => {
        handler(mutations);
      });

      // TODO: We should detect if options wasn't memo'ed because that
      // will recreate the observer on every render
      observer.observe(node, options);
      return () => observer.disconnect();
    }
  }, [node, options, handler]);
}
